//! Auth
export const send_login_otp = 'api/app/customer/user_login';
export const customer_login = 'api/app/customer/otp_verify';
export const customer_signup = 'api/app/customer/user_signup';
export const customer_logout = '';

//* Customer Detail
export const update_customer_details = (userId) => `api/users/${userId}`;
export const get_customer_details = 'api/app/customer/get_user_profile';

//* Address
export const get_customer_address = 'api/e-commerce/get_address';
export const create_customer_address = 'api/e-commerce/add_address';
export const update_customer_address = 'api/e-commerce/update_address';
export const delete_customer_address = 'api/e-commerce/delete_address';

//* History
export const get_recharge_history = 'api/recharge/get-recharge-history';
export const get_yatra_history = 'api/user/yatraOrderHistory';
export const get_product_history = 'api/user/getCustomerOrder';
export const get_puja_history = 'api/e-commerce/get_customer_puja_history';
export const get_pitr_paksha_history = (id) => `api/app/customer/get_book_pitra_puja/${id}`

//! Recharge
export const get_recharge_service_list = 'api/recharge/get_services_list';

//! Milan Sathi
export const get_milan_sathi_profile = ({ userId }) => `api/users/search?currentUserId=${userId}`;
export const send_connection_request = 'api/connections/request';

//* For making Payment
export const recharge_data = 'api/recharge/rechargeData';
export const bill_payment = 'api/recharge/billPayment';
export const success_recharge = 'api/app/recharge/success-recharge';
export const refund_recharge = 'api/app/recharge/refund-recharge';
export const refund_success_recharge = 'api/app/recharge/refund-success-rechar';
export const failed_recharge = 'api/app/recharge/failed-recharge';

//! Sanchar
export const get_category = 'api/admin/getSeparateCategories'; //* Give all category - Podcast | News | Yatra | Videoclip
export const get_sub_category = 'api/admin/getSubCategoryByCategoryId';
export const get_video_by_sub_category = 'api/admin/getVideosBySubCategoryId';
export const get_podcast_by_sub_category = 'api/admin/getAudioBySubCategory';

//* News
export const get_breaking_news = 'api/user/getBreakingNews';
export const get_news_category = 'api/user/getNewscategory';
export const get_news_by_categoryId = 'api/user/getNewsByCategory';

//* Live
export const get_live_video = 'api/admin/getLive';

//* Daily Darshan
export const get_daily_darshan = 'api/admin/getDailyDarshan';

//* Consultancy
export const create_consultancy = 'api/app/customer/consultant_request';

//! Ecommerce
//* Yatra
export const get_yatra = 'api/app/customer/get_all_yatra';
export const get_yatra_details = 'api/app/customer/yatra_details_by_id';
export const get_yatra_child_categories = 'api/app/customer/yatra_child_categories';
export const book_yatra = 'api/user/bookYatra';

//* Products
export const get_product_category = 'api/e-commerce/get_product_category';
export const get_product = 'api/e-commerce/get_products';
export const add_product_to_cart = 'api/e-commerce/add_to_cart';
export const update_product_cart = 'api/e-commerce/update_cart_item_quantity';
export const get_product_cart = 'api/e-commerce/get_customer_cart';
export const book_product_cart = 'api/e-commerce/order_product';
export const book_pitr_paksha = 'api/app/customer/book_pitra_puja';

//* Puja
export const get_puja = 'api/e-commerce/get_puja';
export const book_puja = 'api/e-commerce/book_puja';

//! Static Page
export const get_terms_of_use = 'api/admin/getTermsAndCondition';
export const get_privacy_policy = 'api/admin/getPrivacyPolicy';
export const get_refund_policy = 'api/admin/getRefundPolicy';
export const get_about_us = 'api/admin/getAboutUs';